import { strings } from "../";

const followUpNoteSchema = {
  was_expected_outcome: {
    required: false,
    errorMessagePrefix:
      strings.form.validation.errorMessagePrefix.wasExpectedOutcome,
  },
  were_there_complications: {
    required: false,
    errorMessagePrefix: strings.form.validation.errorMessagePrefix.wereThereComplications,
  },
};

export default followUpNoteSchema;
